import { TemplateElement } from '@webtides/element-js';

import styles from './_dropdown-sort.css';
import DropDownEvents from './DropDownSortEvents';

import template from './dropdown-sort.template';

export default class DropdownSort extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [styles], ...options });
    }

    properties() {
        return {
            options: [
                { value: 0, label: 'Default' },
                { value: 1, label: 'Hover' },
                { value: 2, label: 'Active', selected: true },
                { value: 3, label: 'Focus' },
            ],
        };
    }

    updateSelected(value) {
        this.options = this.options.map(option => Object.assign(option, { selected: value === option.value }));
        this.dispatch(DropDownEvents.CHANGE_OPTION, this.selectedOption, true);
        this.requestUpdate();
    }

    events() {
        return {
            '[data-value]': {
                click: ev => {
                    const value = ev.target.dataset.value;
                    this.updateSelected(value);
                },
            },
            select: {
                change: ev => {
                    const value = ev.target.value;
                    this.updateSelected(value);
                },
            },
        };
    }

    get selectedOption() {
        const selectedOption = this.options.find(option => option.selected);

        if (!selectedOption) {
            return this.defaultOption;
        }

        return selectedOption;
    }
    get defaultOption() {
        const defaultOption = this.options.find(option => option.default);

        if (!defaultOption) {
            return this.options[0];
        }

        return defaultOption;
    }
    get value() {
        return this.selectedOption.value;
    }

    template() {
        return template(this);
    }
}
